import { useApolloClient, useMutation } from '@apollo/client';
// Api
import { LOGIN_AS } from 'api/auth/mutations';
import ENV from 'api/env';
// Types
import { LoginAs, LoginAsVariables } from 'api/auth/types/LoginAs';
import { AuthUser } from 'context/AppContext';
// Helpers
import { setAuthUserToCookies } from 'helpers/cookies';
// UI
import { errorNotification } from 'ui/Notification';

const LOGIN_AS_ERROR_MESSAGE = 'Could not log in as this user';

type UseLoginAsResult = {
  loginAs: (userId: string) => Promise<void>;
  loading: boolean;
};

export const useLoginAs = (): UseLoginAsResult => {
  const apolloClient = useApolloClient();
  const [loginAsMutation, { loading }] = useMutation<LoginAs, LoginAsVariables>(
    LOGIN_AS
  );

  const loginAs = async (userId: string): Promise<void> => {
    try {
      const { data } = await loginAsMutation({
        variables: { input: { userId } },
      });

      const targetUser = data?.loginAs;

      if (!targetUser) {
        errorNotification(LOGIN_AS_ERROR_MESSAGE);
        return;
      }

      const targetAuthUser: AuthUser = {
        id: targetUser.id,
        email: targetUser.email,
        role: targetUser.role,
        firstName: targetUser.firstName,
        lastName: targetUser.lastName,
        accessToken: targetUser.accessToken,
        refreshToken: targetUser.refreshToken,
        isInterviewer: false,
      };

      setAuthUserToCookies(targetAuthUser);

      await apolloClient.clearStore();

      window.location.assign(ENV.CAMPAIGN_APP_URL);
    } catch (err) {
      errorNotification(LOGIN_AS_ERROR_MESSAGE);
    }
  };

  return { loginAs, loading };
};
